export class BankDetailsEntityModel {
  constructor(u) {
    (this.bank_name = u.bank_name),
      (this.brange = u.brange),
      (this.acount_holder_name = u.acount_holder_name),
      (this.account_no = u.account_no);
  }
}
